import React, { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

/* 手写签名板（触屏 / 鼠标 · pointer events）。onChange(dataURL | "") */
export function SignaturePad({ zh, onChange, height = 160, testid = "signature-pad", caption }) {
  const T = (z, e) => (zh ? z : e);
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);
  useEffect(() => {
    const c = ref.current;
    const dpr = window.devicePixelRatio || 1;
    const w = c.clientWidth || 320;
    c.width = w * dpr; c.height = height * dpr;
    const ctx = c.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2.4; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#1e1b4b";
  }, [height]);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + 0.1, y + 0.1); ctx.stroke(); ref.current.setPointerCapture?.(e.pointerId); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.lineTo(x, y); ctx.stroke(); };
  const up = () => { if (!drawing.current) return; drawing.current = false; setEmpty(false); onChange(ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange(""); };
  return (
    <div className="space-y-1.5" data-testid={testid}>
      <div className="relative rounded-xl border-2 border-dashed border-indigo-300 bg-white overflow-hidden" style={{ height }}>
        <canvas ref={ref} data-testid={`${testid}-canvas`} className="w-full h-full touch-none cursor-crosshair" style={{ height }}
          onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} onPointerCancel={up} />
        {empty && <p className="absolute inset-0 flex items-center justify-center text-sm text-slate-300 pointer-events-none" data-testid={`${testid}-hint`}>{T("请在此手写签名", "Sign here")}</p>}
      </div>
      <div className="flex items-center justify-between text-[11px] text-slate-400">
        <span>{caption ?? T("签名将保存为电子签名并附在领用单 PDF 上", "Saved as e-signature on the receipt PDF")}</span>
        <button type="button" data-testid={`${testid}-clear`} onClick={clear} className="inline-flex items-center gap-1 text-slate-500 hover:text-slate-800"><Eraser className="h-3 w-3" />{T("重写", "Clear")}</button>
      </div>
    </div>
  );
}
